import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export interface CMSPublishRequest {
  platform: 'wordpress' | 'tistory' | 'naver_blog';
  content: string;
  metadata: {
    title: string;
    metaDescription?: string;
    categories?: string[];
    tags?: string[];
    featuredImage?: string;
  };
}

export interface CMSPublishResponse {
  success: boolean;
  postId?: string;
  url?: string;
  editUrl?: string;
  error?: string;
}

export class CMSService {
  /**
   * CMS에 콘텐츠 발행
   */
  async publish(request: CMSPublishRequest): Promise<CMSPublishResponse> {
    try {
      const response = await apiClient.post<CMSPublishResponse>(
        '/v2/cms/publish',
        request
      );

      if (!response.data.success) {
        throw new Error(response.data.error || 'CMS 발행에 실패했습니다.');
      }

      return response.data;
    } catch (error: any) {
      console.error('CMS publish error:', error);
      throw new Error(error.response?.data?.error || 'CMS 발행에 실패했습니다.');
    }
  }
}

export const cmsService = new CMSService();

